import { render, staticRenderFns } from "./DeclarationOfConformityDialog.vue?vue&type=template&id=58a67354&scoped=true"
import script from "./DeclarationOfConformityDialog.vue?vue&type=script&lang=js"
export * from "./DeclarationOfConformityDialog.vue?vue&type=script&lang=js"
import style0 from "./DeclarationOfConformityDialog.vue?vue&type=style&index=0&id=58a67354&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a67354",
  null
  
)

export default component.exports